import SCMReportUploadModal from "./SCMReportUploadModal";

export default SCMReportUploadModal;
